import './index.scss';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useProfile } from '../../../store/Auth/authHooks';
import {
  useFetchSpacesManagementSpacesByCompany,
  useSpacesManagementCompanySpaces,
} from '../../../store/SpacesManagement/spacesManagementHooks';
import { useAddRepeatableGuest } from '../../../store/guests-management/guestsManagementHooks';
import {
  useCloseOldModal,
  useModalData,
  useStartLoader,
  useStopLoader,
} from '../../../store/modal/modalHooks';
import { Button, Form, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { InviteRepeatableGuestForm } from '../../pages/my-guests/InviteRepeatableGuestForm';
import { AddNewRepeatableGuestRequestDto } from '../../../API/guests/dto/request/add-new-repeatable-guest.request.dto';
import Toast from '../../shared/Toast/Toast';

export interface InviteRepeatableVisitorFormValues {
  fullName: string;
  email: string;
  phone: string;
  spaceId: number;
  startDate: Date[];
  endDate: Date[];
  licenseNumber: string;
  parkingNumber: string;
  parkingFloorNumber: string;
}

const InviteRepeatableVisitorModal = () => {
  const profile = useProfile();
  const { t } = useTranslation();
  const closeModal = useCloseOldModal();
  const startLoader = useStartLoader();
  const stopLoader = useStopLoader();
  const inviteGuest = useAddRepeatableGuest();
  const companySpaces = useSpacesManagementCompanySpaces();
  const fetchCompanySpaces = useFetchSpacesManagementSpacesByCompany();

  useEffect(() => {
    fetchCompanySpaces().finally();
  }, [profile?.company?.id!]);

  const form = useForm<InviteRepeatableVisitorFormValues>();
  const {
    handleSubmit,
    formState: {},
  } = form;

  useEffect(() => {
    if (companySpaces.length) {
      form.setValue('spaceId', companySpaces[0].id);
    }
  }, [companySpaces]);

  const onSubmit = async (data: InviteRepeatableVisitorFormValues) => {
    await startLoader();
    const newGuest: AddNewRepeatableGuestRequestDto = {
      email: data.email,
      company_space_id: data.spaceId,
      phone: data.phone,
      full_name: data.fullName,
      start_date: new Date(data.startDate[0]).getTime(),
      end_date: new Date(data.endDate[0]).getTime(),
    };
    try {
      await inviteGuest(newGuest);
      Toast('success-request', t('VISITOR_ADDED_SUCCESSFULLY'));
      closeModal();
    } catch (error: any) {
      Toast(
        'error',
        error.response?.data?.error?.message || 'Failed to create visitor'
      );
    } finally {
      await stopLoader();
    }
  };

  return (
    <div className="invite-new-guest-modal">
      <div className="form-modal">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <ModalHeader>
            <p className="form-header-title">
              {t('INVITE_REPEATABLE_VISITOR')}
            </p>
          </ModalHeader>
          <ModalBody>
            <InviteRepeatableGuestForm form={form} />
          </ModalBody>
          <ModalFooter className="invite-new-guest-modal-buttons">
            <Button type="button" color="" onClick={closeModal}>
              {t('CLOSE_BUTTON')}
            </Button>{' '}
            <Button type="submit" color="primary">
              {t('INVITE')}
            </Button>{' '}
          </ModalFooter>
        </Form>
      </div>
    </div>
  );
};

export default InviteRepeatableVisitorModal;
